import {useSearchParams} from "react-router-dom";
import {Tooltip} from "react-tooltip";
import RankIcon from "../rank-icon";

const BetChatMessage = props => {
    const {message} = props

    const [searchParams, setSearchParams] = useSearchParams()


    const handleBetDetail = () => {

        try {
            searchParams.set('modal', 'bet')
            searchParams.set('reference', message?.message?.replaceAll('#', ''))
            setSearchParams(searchParams)
            // setSearchParams({
            //     modal: 'bet',
            //     reference: message?.message?.replaceAll('#','')
            // })
        } catch (e) {
            console.error(e)
        }

    }
    return (
        <div className="chat__message chat__message--share">
            <p>
                <span className="chat__user">
                                              <Tooltip className="tooltip-me" id="rank-tooltip"/>

                    {
                        message.ranki &&
                        <span
                            data-tooltip-id="rank-tooltip"
                            data-tooltip-content={message?.rank?.toUpperCase()}
                            data-tooltip-place="top"
                        >
                                <RankIcon icon={message.ranki}/>
                               </span>
                    }

                    <button className="chat__name" type="button">
                    {message.username}:
                  </button>
                </span>

                <a onClick={handleBetDetail} className="link-underline">
                    {message.message}
                </a>
            </p>
        </div>
    )

    // return (
    //     <div className="chat__message chat__message--share">
    //         <p>
    //             <span className="chat__user">
    //                                           <Tooltip className="tooltip-me" id="rank-tooltip"/>
    //                           <span
    //                               data-tooltip-id="rank-tooltip"
    //                               data-tooltip-content={message.rank}
    //                               data-tooltip-place="top"
    //                               // className={`chat__rank chat__rank--${message.rank}`}
    //                           >
    //                             <SvgIcon id={message.rank}/>
    //                            </span>
    //
    //               <button className="chat__name" type="button">
    //                 {message.username}
    //               </button>
    //             </span>
    //             :
    //             <span>
    //                 {t(`notifications.${message.message}`)}
    //             </span>
    //         </p>
    //         <button
    //             className="chat__btn"
    //             type="button"
    //             onClick={handleBetDetail}
    //         >
    //             <span className="chat__info one-line">
    //               <i className="ti ti-dice"/>
    //               <span>{message.game}</span>
    //             </span>
    //
    //             {/*<span className="chat__info">*/}
    //             {/*  <i className="ti ti-graph"/>*/}
    //             {/*  <span>{Big(message?.multiplier || 0).toFixed(2)}x</span>*/}
    //             {/*</span>*/}
    //             {/* or .chat__coin--down */}
    //             <span className="chat__coin chat__coin--up">
    //                 <InstrumentIcon code={message.code}/>
    //               <span>{Big(message.amount).toNumber()}</span>
    //             </span>
    //         </button>
    //     </div>
    //
    // )
}

export default BetChatMessage
